'use client';

import React, { cache, use, useCallback, useEffect, useState } from 'react';
import {
  QueryClientProvider,
  QueryClient,
  HydrationBoundary,
  dehydrate,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useReactQueryRestore } from './ReactQueryRestoreProvider';

// QueryClient 인스턴스 생성을 컴포넌트 바깥으로 이동
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
});

function ReactQueryProvider({ children }: React.PropsWithChildren) {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnReconnect: true,
          refetchOnWindowFocus: false,
          staleTime: 1000 * 60 * 2,
          retry: 1,
          // gcTime: 1000 * 60 * 2,
        },
      },
    })
  );
  const dehydratedState = dehydrate(client);
  const isLocal = process.env.NEXT_PUBLIC_MODE === 'local';
  const { isAllLoaded, setIsAllLoaded } = useReactQueryRestore();

  const queryRestore = useCallback(() => {
    // if (client) {
    //   const filteredQueryData = window.history.state?.filteredQueryData;
    //   if (filteredQueryData) {
    //     filteredQueryData.forEach((query: any) => {
    //       const [queryKey, queryValue] = query;
    //       client.setQueryData(queryKey, queryValue);
    //     });
    //     setIsAllLoaded(true);
    //   }
    // }
  }, [client, setIsAllLoaded]);

  const pageShow = useCallback(
    (e: PageTransitionEvent) => {
      if (!e.persisted) {
        queryRestore();
      }
    },
    [queryRestore]
  );

  useEffect(() => {
    queryRestore();
    window.addEventListener('pageshow', pageShow);
    return () => {
      window.removeEventListener('pageshow', pageShow);
    };
  }, [queryClient]);

  // useEffect(() => {
  // 로컬에서는 bfcache가 안되서 스크롤 유지용으로 세션스토리지 활성화
  //   if (isLocal) {
  //     persistQueryClient({
  //       queryClient: client,
  //       persister: createSyncStoragePersister({
  //         storage: window.sessionStorage,
  //         // serialize: data => compress(JSON.stringify(data)),
  //         // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  //         // deserialize: data => JSON.parse(decompress(data)),
  //       }),
  //       // maxAge: Infinity,
  //     });
  //   }
  // }, []);

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     queryClient.clear();
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [queryClient]);

  return (
    <QueryClientProvider client={client}>
      <HydrationBoundary state={dehydratedState}>
        {children}
        {/* <ReactQueryStreamedHydration>{children}</ReactQueryStreamedHydration> */}
        <ReactQueryDevtools initialIsOpen={false} />
      </HydrationBoundary>
    </QueryClientProvider>
  );
}

export default ReactQueryProvider;
